import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnaliComponent } from './annali.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AnnaliComponent],
  exports:[AnnaliComponent]
})
export class AnnaliModule { }
